import { AppContextState } from "src/AppContextProvider";

/**
 * Gates the /developer route.
 * Mirrors AdminNav's "developer" tab visibility:
 * token:read AND at least one token mutate ability (update or create).
 * Viewers (read-only with no token mutate abilities) are rejected,
 * closing pentest finding GRWBKK-1393 / PENTEST-138 / 3.3.1.
 */
export const canAccessDeveloperRoute = (context: AppContextState): boolean => {
  const p = context.currentPermissions;
  return (
    p.validateOrg("token", "read") &&
    (p.validateOrg("token", "update") || p.validateOrg("token", "create"))
  );
};
